import React from 'react';
import { Button } from 'semantic-ui-react';
import classNames from 'classnames';

import './Button.scss';

export default ({ type = 'button', className, onClick, isFull, isGhost, noBorder, isGreen, buttonSmall, staticContext, ...props }) => (
	<Button
		className={classNames('button', className, {
			'button--full': isFull,
			'button--ghost': isGhost,
			'button--no-border': noBorder,
			'button--small': buttonSmall,
      // this awfully named flag is a stopgap for making buttons green instead of orange on a few pages (part of rebranding)
      // bigger changes will come later and that will include refactoring these flags
			'button--green': isGreen,
		})}
		onClick={onClick}
		disabled={props.disabled}
		type={type}
		{...props}
	>
		{props.children}
	</Button>
);
